import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useShowToast } from '../../redux/slices/toasts/hooks';

/**
 * design: workspaces c8. The toast after a join: "You joined {workspace}." and, when the home
 * workspace is known, "{home} is one click away in the workspace menu." The menu is at the top of
 * the sidebar, on the rail and in the account sheet of mobile web, so the text does not name a place.
 */
export function useJoinedToast(): (workspaceName: string, homeName: string | null) => void {
  const intl = useIntl();
  const { showSuccess } = useShowToast();

  return useCallback(
    (workspaceName: string, homeName: string | null) => {
      const title = intl.formatMessage(
        { id: 'app.sml.team.accept.joinedTitle', defaultMessage: 'You joined {workspace}.' },
        { workspace: workspaceName }
      );
      if (homeName === null) {
        showSuccess(title);
        return;
      }
      showSuccess(
        intl.formatMessage(
          {
            id: 'app.sml.team.accept.joinedHomeInMenu',
            defaultMessage: '{home} is one click away in the workspace menu.',
          },
          { home: homeName }
        ),
        title
      );
    },
    [intl, showSuccess]
  );
}
